import { css } from "@emotion/react";

import { BannerType, BannerView } from "@dotnet/telematics-design-system";

import DateTime from "components/DateTime";

import { LimitWarningBannerProps } from "./types";

const LimitWarningBanner = ({
    testId,
    title,
    date
}: LimitWarningBannerProps) => {
    return (
        <BannerView
            data-testid={testId}
            bannerType={BannerType.Warning}
            title={
                <>
                    {title}:{" "}
                    <span
                        css={css({
                            fontWeight: "700"
                        })}
                    >
                        <DateTime date={date} />
                    </span>
                </>
            }
            css={css({ marginTop: "16px" })}
        />
    );
};

export { LimitWarningBanner };
